import { axiosInstance } from "./config";


export const getAllSubCategories = async () => {
  const res = await axiosInstance.get('/subcategories');
  return res.data;
};

export const createSubCategory = async (data) => {
  const res = await axiosInstance.post('/subcategories', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const updateSubCategory = async (id, data) => {
  const res = await axiosInstance.post(`/subcategories/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const deleteSubCategory = async (id) => {
  const res = await axiosInstance.delete(`/subcategories/${id}`);
  return res.data;
};
